import NavBar from "./components/NavBar";
import Temp from "./components/temp";
import Skill from "./components/skill";
import Project from "./components/project";
import Contact from "./components/contact";
import Footer from "./components/footer";
export default function App() {
  return (
    <div>
      <NavBar />
      <Temp />
      <Skill />
      <Project />
      <Contact />
      <Footer />
    </div>
  );
}
